import { MagicLinkAuthExtractor } from '~domain/helper/url/magic-link/magic-link-auth-extractor';
import { UrlParamHelper } from '~domain/helper/url/url-param-helper';
import { ApplicationAuthentication } from '~domain/model/account/application-authentication';
import { MagicLinkParamKeys } from '~domain/model/url/url-parameters';

// Generates application page magic link and extracts values from query
export class MagicLinkHelper {
  private urlParamHelper: UrlParamHelper = new UrlParamHelper();

  // Parse query string and return Authentication
  public extractAuthFromURLQuery(urlQuery: string): ApplicationAuthentication {
    return new MagicLinkAuthExtractor().extractAuthFromURLQuery(urlQuery);
  }

  public generateCoverage(baseUrl: string, token: string, applicationId: string, languagueId?: string): string {
    const url: URL = new URL(baseUrl);
    url.pathname = 'coverage';

    return this.appendAuthParams(url.toString(), token, applicationId, languagueId);
  }

  public generateProductSelector(baseUrl: string, token: string, applicationId: string, languageId?: string): string {
    const url: URL = new URL(baseUrl);
    url.pathname = 'start';

    return this.appendAuthParams(url.toString(), token, applicationId, languageId);
  }

  public generateReceipt(baseUrl: string, token: string, applicationId: string, languagueId?: string): string {
    const url: URL = new URL(baseUrl);
    url.pathname = 'receipt';

    return this.appendAuthParams(url.toString(), token, applicationId, languagueId);
  }

  public generateReferralProgram(baseUrl: string, token: string, applicationId: string, languagueId?: string): string {
    const url: URL = new URL(baseUrl);
    url.pathname = 'referral-program';

    return this.appendAuthParams(url.toString(), token, applicationId, languagueId);
  }

  public generateReview(baseUrl: string, token: string, applicationId: string, languagueId?: string): string {
    const url: URL = new URL(baseUrl);
    url.pathname = 'review';

    return this.appendAuthParams(url.toString(), token, applicationId, languagueId);
  }

  private appendAuthParams(baseUrl: string, token: string, applicationId: string, languagueId?: string): string {
    const params: Map<string, string> = new Map([
      [MagicLinkParamKeys.language, languagueId],
      [MagicLinkParamKeys.token, token],
      [MagicLinkParamKeys.applicationId, applicationId],
    ]);

    return this.urlParamHelper.appendParams(baseUrl, params);
  }
}
